let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("khJNX")).then(() => parcelRequire('4dvXu'));